import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTA() {
  return <section className="w-full bg-surface px-4 py-20 text-navy sm:py-24" data-id="element-73" data-mp="3udf9v3lh1fkb">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-74" data-mp="c7adc3u6m4g0">
        <h2 className="font-serif text-5xl leading-tight sm:text-6xl" data-id="element-75" data-mp="c4o6y7j11uzd">
          Vous êtes le briseur de cycle
          <br data-id="element-76" data-mp="87jsegrc6ije" />
          <span className="text-amber" data-id="element-77" data-mp="m4ou64k0ov8u">que votre lignée attendait.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-78" data-mp="m2lustwz5prg">
          Les schémas s’arrêtent avec vous. La guérison commence aujourd’hui. L’héritage que vous laissez commence
          maintenant.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-slate" data-id="element-79" data-mp="qwq2jfe2e1tl">
          300 pages. 11 guides complets. 84 cartes de phrases de guérison. Tout ce dont vous avez besoin pour ordonner
          votre système et sauver votre histoire.
        </p>
        <div className="mx-auto mt-10 max-w-xl rounded-2xl border border-amber/50 bg-mist p-6" data-id="element-80" data-mp="2c4oauvjf355o">
          <p className="text-sm font-bold text-navy" data-id="element-81" data-mp="2h3rgoi781fep">🚀 Offre de lancement active</p>
          <div className="mx-auto mt-3 h-2 overflow-hidden rounded-full bg-amber/20" data-id="element-82" data-mp="2h5u6p28dj8jf">
            <div className="h-full w-[72%] rounded-full bg-amber" data-id="element-83" data-mp="2m1j7f8w4qvhb" />
          </div>
          <p className="mt-2 text-xs font-medium text-slate" data-id="element-84" data-mp="2r3ibkkzp1wfb">72% des places déjà revendiquées</p>
        </div>
        <div className="mt-8" data-id="element-85" data-mp="2v38ww96gbkcg">
          <CTAButton href="#collection-complete" size="large" data-id="element-86" data-mp="302ltvmr1e7sr">
            ⚡ ACCÈS INSTANTANÉ
          </CTAButton>
        </div>
        <p className="mt-5 text-xs leading-6 text-slate sm:text-sm" data-id="element-87" data-mp="34t2a1em8s7it">
          🔒 Paiement Sécurisé · ⚡ Téléchargement Immédiat · 🛡️ Garantie 7 Jours · 💳 Carte Bancaire · PayPal · ♾️
          Accès à Vie
        </p>
      </Reveal>
    </section>;
}